import React from "react";
import { useAppSelector } from "../../../redux/hooks";
import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { AvanzadoCamaraComponent } from "../../../components/Avanzados/AvanzadoCamaras";
import { ItemFrigorifico, ItemPlanta } from "../../../components/Avanzados/interfaces/avanzado.interface";

export const AvanzadoCamarasPage: React.FC = () => {
    const navigate = useNavigate();

    const CamaraData = useLocation();
    

   // const frioId: string = CamaraData.state.frioId;
   const planta: ItemPlanta = CamaraData.state.planta;
   const frio: ItemFrigorifico = CamaraData.state.frio;

    const {userData } = useAppSelector((state) => state.authReducer)


    //Si no es administrador no permite ingresar
    React.useEffect(() => {
        if(userData?.role !== "ADMIN")
            {
                navigate('/');
            }
    },[userData, navigate])

    return (
        <Container 
            maxWidth={false} 
            sx={{
                px: 2, // padding horizontal: 2*8px = 16px
            }}
        > 
            {/*<HeaderComponent 
                title="Control Avanzado"
                description= ""
                //element={<Button fullWidth variant="contained" onClick ={()=> navigate("/avanzado")} >Ir a Lista de Frigorificos Registarados</Button>}
            />*/}
            <AvanzadoCamaraComponent propsPlanta={planta} propsFrio={frio}/>

        </Container>
    )

}